import { render, staticRenderFns } from "./PageRightSidebar.vue?vue&type=template&id=a2caf01c&scoped=true"
import script from "./PageRightSidebar.vue?vue&type=script&lang=js"
export * from "./PageRightSidebar.vue?vue&type=script&lang=js"
import style0 from "./PageRightSidebar.vue?vue&type=style&index=0&id=a2caf01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2caf01c",
  null
  
)

export default component.exports